// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileAvatar_avatar__Yekso {
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/ProfileAvatar/ProfileAvatar.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ","sourcesContent":[".avatar {\r\n    z-index: 10;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `ProfileAvatar_avatar__Yekso`
};
export default ___CSS_LOADER_EXPORT___;
